// src/components/seo/LocalizedContent.tsx
import { useParams } from 'react-router-dom';
import { SupportedLanguage, getLanguageFromURL } from '@/config/routes';

interface LocalizedContentProps {
  translations: Record<SupportedLanguage, string>;
  component?: keyof JSX.IntrinsicElements;
  className?: string;
}

const LocalizedContent = ({
  translations,
  component: Component = 'span',
  className = ''
}: LocalizedContentProps) => {
  const { pathname } = useParams();
  const currentLang = getLanguageFromURL(pathname || '');
  const content = translations[currentLang] || translations['en'];

  return (
    <Component className={className}>
      {content}
    </Component>
  );
};

export default LocalizedContent;